import { ReactElement } from 'react'
import { ReactQueryDevtools } from 'react-query/devtools'
import { QueryClient, QueryClientProvider } from 'react-query'

import { isProduction } from '../../helpers/common'

function ReactQueryContainer(props: { children: ReactElement | ReactElement[] }): ReactElement {
  const { children } = props

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // query options
        retry: 2,
        suspense: false,
        refetchOnWindowFocus: false,
        staleTime: 60000,
        retryDelay: 500,
      },
      mutations: {
        // mutation options
        retry: 1,
        retryDelay: 500,
      },
    },
  })

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {!isProduction() ? <ReactQueryDevtools initialIsOpen={false} position="bottom-right" /> : <></>}
    </QueryClientProvider>
  )
}

export default ReactQueryContainer
